export default __webpack_public_path__ + "static/home-mobile-2-95df9c916457d99a1661c64b554f2f3f.png";